import React from 'react'
import { HStack, Text, Tag, Wrap, WrapItem, Box } from '@chakra-ui/react'
import { FiTag } from 'react-icons/fi'
import { SearchResultItem } from '@/types'

interface SearchResultCardSubtitleProps {
  result: SearchResultItem
}

export default function SearchResultCardSubtitle({ result }: SearchResultCardSubtitleProps) {
  const subtitleElements: React.ReactNode[] = []

  // Add tags if they exist
  if (Boolean(result.tags?.length)) {
    subtitleElements.push(
      <HStack key="tags" spacing={2} align="center">
        <Box color="gray.400">
          <FiTag size="12px" />
        </Box>
        <Wrap spacing={1}>
          {result.tags.slice(0, 3).map((tag, index) => (
            <WrapItem key={index}>
              <Tag size="sm" colorScheme="blue" variant="subtle" borderRadius="full" fontSize="xs">
                {tag}
              </Tag>
            </WrapItem>
          ))}
          {result.tags.length > 3 && (
            <WrapItem>
              <Tag
                size="sm"
                variant="outline"
                borderRadius="full"
                color="gray.500"
                borderColor="gray.300"
                fontSize="xs"
              >
                +{result.tags.length - 3}
              </Tag>
            </WrapItem>
          )}
        </Wrap>
      </HStack>
    )
  }

  // Add created at date
  subtitleElements.push(
    <Text key="date" fontSize="sm" color="gray.500">
      {new Date(result.created_at).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })}
    </Text>
  )

  const separator = (
    <Text fontSize="md" color="gray.400" fontWeight="bold">
      ·
    </Text>
  )

  // Join elements with interpunct
  return (
    <HStack spacing={2} align="center" flexWrap="wrap" minW={0}>
      {subtitleElements.map((element, index) => (
        <React.Fragment key={index}>
          {element}
          {index < subtitleElements.length - 1 && separator}
        </React.Fragment>
      ))}
    </HStack>
  )
}
